import React from 'react';

export type TeamVisualChipSize = 'sm' | 'md';

export type TeamVisualChipProps = {
  abbreviation: string;
  accentColor: string;
  size?: TeamVisualChipSize;
  className?: string;
  testId?: string;
};

const SIZE_CLASSES: Record<TeamVisualChipSize, string> = {
  sm: 'h-7 min-w-[2.25rem] px-1 text-[10px] rounded-md',
  md: 'h-9 min-w-[2.75rem] px-1.5 text-[11px] rounded-md',
};

const TeamVisualChip: React.FC<TeamVisualChipProps> = ({
  abbreviation,
  accentColor,
  size = 'md',
  className = '',
  testId = 'team-visual-chip',
}) => {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center border-2 bg-secondary-900/40 font-bold uppercase tracking-tight ${SIZE_CLASSES[size]} ${className}`.trim()}
      style={{ borderColor: accentColor, color: accentColor }}
      data-testid={testId}
      aria-hidden="true"
    >
      {abbreviation}
    </span>
  );
};

export default TeamVisualChip;
